import paths from '@/paths';
import { TDraftRoutes, TDraftStatus, TNavOption } from '@/types';

export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || '';
export const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://faunaexplore.com';

/** Normalize to a single trailing slash (backend may expect `/api/v1/content/`). */
function withTrailingSlash(url: string): string {
  return `${url.replace(/\/+$/, '')}/`;
}

/** Full URL for ContentWrapperDto JSON. Set NEXT_PUBLIC_CONTENT_URL to override (e.g. CDN). */
export function getContentApiUrl(): string {
  const explicit = process.env.NEXT_PUBLIC_CONTENT_URL?.trim();
  if (explicit) return withTrailingSlash(explicit);
  const base = baseUrl.replace(/\/$/, '');
  if (!base) return '';
  // NEXT_PUBLIC_BASE_URL may be host root (…/8080) or already include /api/v1
  if (/\/api\/v1$/i.test(base)) {
    return withTrailingSlash(`${base}/content`);
  }
  return withTrailingSlash(`${base}/api/v1/content`);
}
export const stripePK =
  process.env.NODE_ENV === 'production'
    ? process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY_PROD || ''
    : process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY_TEST || '';
export const sessionHash =
  process.env.SESSION_KEY || '3ecb3a232a06c3f25ca085d4b956576cfd6dda2cb976293e7068dc39c9000208';

export const months = [
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
];

// change values to their url values -> 10, 20, 50, 51
export const numVisitors = [
  { value: 1, label: 'Private tour' },
  { value: 2, label: 'Up to 10' },
  { value: 3, label: 'Up to 20' },
  { value: 4, label: 'Up to 50' },
  { value: 5, label: '50+' },
];

export const languages = [
  { label: 'English', value: 1 },
  { label: 'Spanish', value: 2 },
];

export const DRAFT_ROUTES: Record<TDraftRoutes, TDraftRoutes> = {
  activity: 'activity',
  about: 'about',
  photos: 'photos',
};

export const draftTabs: Array<TNavOption> = [
  { value: 1, label: 'Activity type', pathname: '/activity' },
  { value: 2, label: 'Daily itinerary', pathname: '/about' },
  { value: 3, label: 'Features', pathname: '/features' },
  { value: 4, label: 'Photos', pathname: '/photos' },
  { value: 5, label: 'Location', pathname: '/location' },
  { value: 6, label: 'Schedule & Price', pathname: '/schedule-and-price' },
  { value: 7, label: 'Languages', pathname: '/languages' },
  { value: 8, label: "Inclusions", pathname: '/whats-included' },
  { value: 9, label: 'Animals to see', pathname: '/animals-to-see' },
  { value: 10, label: 'Cancellation', pathname: '/cancellation' },
  { value: 11, label: 'Commissions', pathname: '/commissions' },
  { value: 12, label: 'Tour preview', pathname: '/preview' },
];

export const COMPLETED_PROVIDER = 'provider_competed';

export const RESERVATION_TABS = (tourId: string, searchParams: string) => [
  { name: 'Review and contact details', href: paths.reservation.contact(tourId, searchParams) },
  { name: 'Payment Details', href: paths.reservation.paymentDetails(tourId, searchParams) },
  { name: 'Confirmation', href: paths.reservation.confirmation(tourId, searchParams) },
];

export const DRAFT_STATUS: Record<string, TDraftStatus> = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};
